<template>
  <vv-screen-wrapper :style="background">
    <div class="screen-container">
      <slot></slot>
      <div class="cta">
        <vv-button @click="$emit('next')">{{ button }}</vv-button>
      </div>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { VvButton, VvScreenWrapper } from '@/components/common'

export default {
  name: 'TransitionSkeleton',
  components: { VvButton, VvScreenWrapper },
  props: {
    image: {
      type: String,
      required: false,
      default: null
    },
    button: {
      type: String,
      required: true,
      default: 'Next'
    }
  },
  computed: {
    background() {
      return this.image ? `background: url(${this.image}); background-size: cover;` : ''
    }
  }
}
</script>
